import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PermissionState } from '../../../store/actions/user';

const EditPermissions = ({ changePermissions, permissions }: { changePermissions: (index: number) => void; permissions: PermissionState[] | undefined }) => {
    const { t } = useTranslation();
    return permissions?.map((permission: PermissionState, index: number) => {
        return (
            (permission?.enabled || permission?.editable) && (
                <FormControlLabel
                    key={'permission_' + index}
                    onChange={() => changePermissions(index)}
                    control={<Checkbox defaultChecked={permission.enabled} disabled={!permission.editable} />}
                    label={t(`permissions.name.${permission.permissionName}`, { ns: 'user' })}
                />
            )
        );
    });
};

export default EditPermissions;
